import { Banner } from '@hotjar/hotsauce';
import { Trans, useTranslationWithPrefix } from '@hotjar/translations';
import styled from '@emotion/styled';
import { INVOICE_DETAILS_EDIT } from '~/subscription-management/constants/routes';
import { shouldMigrateAddress } from '~/subscription-management/utils/migrated-customers.utils';
import type { Customer } from '~/subscription-management/api/common/model/customer';

const S = {
  Message: styled.span`
    & strong {
      font-weight: 600;
    }
  `,
};

interface Props {
  billingAddress: Customer['billingAddress'];
}

export const UpdateInvoiceDetailsBanner = ({ billingAddress }: Props): JSX.Element | null => {
  const { t } = useTranslationWithPrefix('checkout:invoices.migrate-address-alert');

  if (!shouldMigrateAddress(billingAddress)) {
    return null;
  }

  return (
    <Banner kind="warning" actionText={t('update-now')} actionHref={INVOICE_DETAILS_EDIT}>
      <S.Message>
        <Trans i18nKey="checkout:invoices.migrate-address-alert.short" components={[<strong />]} />
      </S.Message>
    </Banner>
  );
};
